import axios from "axios";
import { CardsStore, GlobalStore } from "stores";
import type {
  CredictcoCardPlanListRes,
  CreditcoCardTopUpReq,
  CreditcoCardWithdrawReq,
  CreditcoCardTransactionRes,
  CreditcoCardTransactionsReq,
  CreditcoCardTransactionsRes,
  ConvertCardToPhysicalReq,
} from "./types/creditco";
import type {
  UsersCard,
  CardsRecentTransactionsRes,
  GetUsersCardSensitiveDataRes,
  OrderCardReq,
  CardProduct,
  CardProductPhoneUpdateReq,
} from "api/types/cardProduct";
import type { CardTemplate } from "helpers/types";

export const getUsersCardsList = async () =>
  axios
    .get<UsersCard[]>("/card-product/ordered-card/list")
    .then(({ data }) => {
      CardsStore.setCryptoCardsList(data);
    })
    .catch((err) => {
      if (err?.response?.data?.message) {
        GlobalStore.setError(err.response.data.message);
      }
    });

export const getCardProductsList = async () =>
  axios.get<CredictcoCardPlanListRes>("/card-product/list", {
    params: { page: 0, itemsPerPage: 20 },
  });

export const getCardProduct = async (cardProductId: number) =>
  axios.get<CardTemplate>(`/card-product/${cardProductId}`);

export const getCardDetails = async (cardId: number) =>
  axios.get<UsersCard>(`/card-product/ordered-card/${cardId}/details`);

export const getCardSensitiveData = async (
  cardId: number,
  oneTimePassword: string
) =>
  axios.get<GetUsersCardSensitiveDataRes>(
    `/card-product/ordered-card/${cardId}/sensitive-data`,
    {
      params: { oneTimePassword },
    }
  );

export const orderCard = async (data: OrderCardReq) =>
  axios.post<CardProduct>("/card-product/order", data);

export const activatePhysicalCard = async (cardId: string, code: string) =>
  axios.post(`/card-product/ordered-card/${cardId}/activate`, {
    publicToken: code,
  });

export const updateCardNote = async (cardId: number, note: string) =>
  axios.put<CardProduct>(`/card-product/ordered-card/${cardId}/add-note`, {
    note,
  });

export const update3dsPhoneNumber = async (
  cardId: number,
  data: CardProductPhoneUpdateReq
) =>
  axios.put(
    `/card-product/ordered-card/${cardId}/change-3ds-phone-number`,
    data
  );

export const topUpCard = async (cardId: number, data: CreditcoCardTopUpReq) =>
  axios.post<CreditcoCardTransactionRes>(
    `/card-product/ordered-card/${cardId}/top-up`,
    data
  );

export const withdrawCard = async (
  cardId: number,
  data: CreditcoCardWithdrawReq
) =>
  axios.post<CreditcoCardTransactionRes>(
    `/card-product/ordered-card/${cardId}/withdraw`,
    data
  );

export const getCardTransactions = async (data: CreditcoCardTransactionsReq) =>
  axios.get<CreditcoCardTransactionsRes>(
    `/card-product/ordered-card/${data.cardId}/transaction/list`,
    {
      params: {
        page: data.page,
        itemsPerPage: data.itemsPerPage,
        search: data.search || "",
      },
    }
  );

export const getRecentCardsTransactions = async () =>
  axios.get<CardsRecentTransactionsRes>(
    `/card-product/ordered-card/transaction/recent`
  );

export const convertCardToPhysical = async (
  cardId: number,
  data: ConvertCardToPhysicalReq
) =>
  axios.post(
    `/card-product/ordered-card/${cardId}/convert-card-to-physical`,
    data
  );
